import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_db0@0.3.1_ioredis@5.6.0_magicast@0.3.5_rollup@4.39.0_terser_zb32omtxuuguhj275ay3n63eam/node_modules/nuxt/dist/pages/runtime/validate.js";
import set_45page_45is_45overlay_45global from "/opt/build/repo/frontend/middleware/set-page-is-overlay.global.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_db0@0.3.1_ioredis@5.6.0_magicast@0.3.5_rollup@4.39.0_terser_zb32omtxuuguhj275ay3n63eam/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  set_45page_45is_45overlay_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}